import { FormControl } from '@angular/forms';

interface ValidationResult {
    [key: string]: boolean;
}

export class CustomValidators {

    static emailValidator(control: FormControl): ValidationResult {
        let EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var valid = EMAIL_REGEXP.test(control.value);
        if (control.value) {
            if (!valid && control.value.length > 0) {
                return { format: true };
            }
        }
        return null;
    }

    static urlValidator(control: FormControl): ValidationResult {
        let URL_REGEXP = /https?:\/\/(?!www | www\.)?([-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6})?\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)(:)?([-a-zA-Z0-9@:%_\+.~#?&//=]*)?/;

        var valid = URL_REGEXP.test(control.value);
        if (control.value) {
            if (!valid && control.value.length > 0) {
                return { format: true };
            }
        }
        return null;
    }

    static trimValidator(control: FormControl): ValidationResult {
        if (control.value) {
            var trimmedValue: string = control.value.trim();
            if (trimmedValue.length === 0) {
                return { required: true };
            }
        }
        return null;
    }

    static numberValidator(control: FormControl): ValidationResult {
        let NUMBER_REGEXP = /[0-9]*\.?[0-9]*/;
        var valid = NUMBER_REGEXP.test(control.value);
        if (control.value && control.value.length === 0) return null;
        if (!valid || control.value === '') {
            return { format: true };
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/utils/validators.ts